import { useEffect } from 'react';

import {
  BUILD_LOGO,
  HEADER_LOGO,
  IS_POWERED,
  SIDEBAR_LOGO,
  subscribeToConfigChanges
} from '../helpers/environment';
import theme from '../styled/theme';

export const usePlatformLogo = () => {
  let isPowered = IS_POWERED ? IS_POWERED === 'true' : false;
  let buildLogo = BUILD_LOGO || theme.images.iconLogoDigibee;
  let headerLogo = HEADER_LOGO || theme.images.pictureNewLogoDigibeeWithText;
  let sidebarLogo = SIDEBAR_LOGO || theme.images.pictureNewLogoDigibeeWithText;

  useEffect(() => {
    const unsubscribe = subscribeToConfigChanges((config: any) => {
      if (config.HEADER_LOGO) {
        headerLogo = config.HEADER_LOGO;
      }
      if (config.IS_POWERED) {
        isPowered = config.IS_POWERED === 'true';
      }
      if (config.SIDEBAR_LOGO) {
        sidebarLogo = config.SIDEBAR_LOGO;
      }
      if (config.BUILD_LOGO) {
        buildLogo = config.BUILD_LOGO;
      }
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return { headerLogo, isPowered, sidebarLogo, buildLogo };
};
